declare namespace $ {

	type $mol_paragraph__title_bog_quiz_session_play_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_2 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['question_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_3 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['timer_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_quiz_session_play_4 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['option_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__click_bog_quiz_session_play_5 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['submit_answer'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_session_play_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_bog_quiz_session_play_7 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['can_submit'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_9 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['your_answer_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_10 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['correct_answer_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_11 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['score_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_13 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['final_score_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_quiz_session_play_14 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['leaderboard_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_section__title_bog_quiz_session_play_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_quiz_session_play_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_paragraph__title_bog_quiz_session_play_17 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['leaderboard_item_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_quiz_session_play_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_bog_quiz_session_play_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_bog_quiz_session_play_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_bog_quiz_session_play_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button__click_bog_quiz_session_play_22 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['option_toggle'] >
		,
		ReturnType< $mol_button['click'] >
	>
	type $mol_button__title_bog_quiz_session_play_23 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_play['option_text'] >
		,
		ReturnType< $mol_button['title'] >
	>
	type $mol_button__style_bog_quiz_session_play_24 = $mol_type_enforce<
		({ 
			'background': ReturnType< $bog_quiz_session_play['option_background'] >,
		}) 
		,
		ReturnType< $mol_button['style'] >
	>
	type $mol_view__sub_bog_quiz_session_play_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_quiz_session_play extends $mol_page {
		session_title( ): string
		state_body( ): readonly(any)[]
		Waiting_text( ): $mol_paragraph
		question_text( ): string
		Question_text( ): $mol_paragraph
		timer_text( ): string
		Timer_text( ): $mol_paragraph
		option_rows( ): readonly(any)[]
		Options_list( ): $mol_list
		submit_answer( next?: any ): any
		can_submit( ): boolean
		Submit_button( ): $mol_button_major
		Review_text( ): $mol_paragraph
		your_answer_text( ): string
		Your_answer( ): $mol_paragraph
		correct_answer_text( ): string
		Correct_answer( ): $mol_paragraph
		score_text( ): string
		Score_text( ): $mol_paragraph
		Finished_text( ): $mol_paragraph
		final_score_text( ): string
		Final_score( ): $mol_paragraph
		leaderboard_rows( ): readonly(any)[]
		Leaderboard( ): $mol_list
		Leaderboard_section( ): $mol_section
		option_toggle( id: any, next?: any ): any
		option_text( id: any): string
		option_background( id: any): string
		leaderboard_item_text( id: any): string
		Leaderboard_text( id: any): $mol_paragraph
		session_id( ): string
		title( ): ReturnType< $bog_quiz_session_play['session_title'] >
		body( ): ReturnType< $bog_quiz_session_play['state_body'] >
		Waiting_view( ): $mol_list
		Question_view( ): $mol_list
		Review_view( ): $mol_list
		Finished_view( ): $mol_list
		Option_button( id: any): $mol_button
		Leaderboard_item( id: any): $mol_view
	}
	
}

//# sourceMappingURL=play.view.tree.d.ts.map